import {DialogFragment, DialogFragmentProps, DialogFragmentState} from "../shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "../shared/StyledComponents";
import {DIVIDER_BLACK, PAGE_FRAGMENT_WIDTH, PD_LG} from "../shared/dimens";
import {Button, TextareaAutosize, Typography} from "@mui/material";
import {BaseApp} from "../shared/BaseApp";

enum ImportExportMode {
  IMPORT,
  EXPORT,
}

export class ImportExportHelper {

  static showImport(onCodeSet: (code: string) => void): void {
    BaseApp.CONTEXT.showDialog(null, () => <ImportExportFragment
      onCodeSet={code => {
        BaseApp.CONTEXT.hideDialog();
        onCodeSet(code);
      }}
      mode={ImportExportMode.IMPORT}/>);
  }

  static showExport(code: string): void {
    BaseApp.CONTEXT.showDialog(null, () => <ImportExportFragment code={code} mode={ImportExportMode.EXPORT}/>);
  }
}

type ImportExportFragmentProps = DialogFragmentProps & {
  mode: ImportExportMode,
  code?: string,
  onCodeSet?: (code: string) => void,
}

type ImportExportFragmentState = DialogFragmentState & {
  code: string,
}

class ImportExportFragment extends DialogFragment<ImportExportFragmentProps, ImportExportFragmentState> {

  protected onCreateState(): ImportExportFragmentState {
    return {
      ...super.onCreateState(),
      code: this.props.code,
    };
  }

  private renderInContainer(children: ReactElement): ReactElement {
    return <StyledBoxColumn style={{padding: PD_LG, flexGrow: 1}}>
      {children}
    </StyledBoxColumn>;
  }

  renderContent(): ReactElement {
    const modeImport = this.props.mode === ImportExportMode.IMPORT;
    const actionText = modeImport ? "Import" : "Export";
    return <StyledBoxColumn style={{width: "90vw", maxWidth: PAGE_FRAGMENT_WIDTH, gap: 0}}>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderBottom: DIVIDER_BLACK}}>
        <Typography variant={"h5"}>{actionText}</Typography>
      </StyledBoxRow>
      <StyledBoxColumn style={{padding: PD_LG}}>
        {this.renderInContainer(<TextareaAutosize
          disabled={!modeImport}
          value={this.state.code} onChange={event => {
          this.setState({code: event.target.value})
        }} minRows={12} style={{fontSize: "150%", fontFamily: "monospace", resize: "none"}}/>)}
      </StyledBoxColumn>
      <StyledBoxRow style={{padding: PD_LG, alignItems: "center", borderTop: DIVIDER_BLACK}}>
        <StyledSpan/>
        {modeImport
          ? <Button onClick={() => this.props.onCodeSet(this.state.code)} variant={"contained"}>Import</Button>
          : <Button onClick={() => {
            navigator.clipboard.writeText(this.state.code);
            BaseApp.CONTEXT.showToast("Copied to clipboard!")
          }} variant={"contained"}>Copy</Button>
        }
      </StyledBoxRow>
    </StyledBoxColumn>;
  }
}